import { render, staticRenderFns } from "./AddDepartmentLicenseModal.vue?vue&type=template&id=16b78c4d"
import script from "./AddDepartmentLicenseModal.vue?vue&type=script&lang=js"
export * from "./AddDepartmentLicenseModal.vue?vue&type=script&lang=js"
import style0 from "./AddDepartmentLicenseModal.vue?vue&type=style&index=0&id=16b78c4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_css-loader@6.11.0_webpack@5.105.4__lodash@4.18.1_webpack@5.105.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports